import { render, staticRenderFns } from "./DashboardCartoes.vue?vue&type=template&id=04c06e14&scoped=true"
import script from "./DashboardCartoes.vue?vue&type=script&lang=js"
export * from "./DashboardCartoes.vue?vue&type=script&lang=js"
import style0 from "./DashboardCartoes.vue?vue&type=style&index=0&id=04c06e14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c06e14",
  null
  
)

export default component.exports